import React from 'react';
import {t} from 'lib/i18n';

/**
 * 편집 좌측 컴포넌트
 */

const EditTitleWrap = () => {
  return (
    <div className='vod_title_wrap'>
      <div className='vod_title'>
        <span className='ic_vod'>{t('영상영역')}</span>
      </div>
      {/* <div className="sound_title">
                <span className="ic_sound">음향</span>
            </div> */}
    </div>
  );
};

export default EditTitleWrap;
